import { render, staticRenderFns } from "./DocCategoryForm.vue?vue&type=template&id=a12dd0da"
import script from "./DocCategoryForm.vue?vue&type=script&lang=js"
export * from "./DocCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a12dd0da')) {
      api.createRecord('a12dd0da', component.options)
    } else {
      api.reload('a12dd0da', component.options)
    }
    module.hot.accept("./DocCategoryForm.vue?vue&type=template&id=a12dd0da", function () {
      api.rerender('a12dd0da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/wps/DocCategoryForm.vue"
export default component.exports